/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme-dark/base/colors";

const { info, dark, background, text } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  body: {
    "--app-bg-default": background.default,
    "--app-surface": background.card,
    "--app-surface-muted": background.muted,
    "--app-surface-elevated": background.surface,
    "--app-border": "rgba(255, 255, 255, 0.08)",
    "--app-border-strong": "rgba(255, 255, 255, 0.12)",
    "--app-shadow-card": "0 18px 40px rgba(2, 6, 23, 0.36)",
    "--app-text-primary": text.focus,
    "--app-text-secondary": text.main,
    "--app-placeholder": "rgba(0, 0, 0, 0.72)",
    "--app-icon-color": text.main,
    "--app-field-bg": background.surface,
    "--app-field-bg-hover": background.card,
    "--app-field-text": text.focus,
    "--app-field-placeholder": "rgba(203, 213, 225, 0.72)",
    "--app-field-border": "rgba(255, 255, 255, 0.12)",
    "--app-field-border-hover": "rgba(255, 255, 255, 0.22)",
    "--app-field-border-focus": info.main,
    "--app-field-ring": "rgba(96, 165, 250, 0.18)",
    backgroundColor: `${background.default} !important`,
    color: `${text.main} !important`,
  },
  "#root": {
    backgroundColor: `${background.default} !important`,
    minHeight: "100vh",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  ".MuiPaper-root": {
    backgroundImage: "none !important",
  },
  ".MuiCard-root, .MuiPaper-root, .MuiDialog-paper, .MuiPopover-paper, .MuiMenu-paper, .MuiAutocomplete-paper, .MuiDrawer-paper, .MuiTableContainer-root, .MuiAccordion-root, .MuiPopover-root .MuiPaper-root": {
    backgroundColor: `${background.card} !important`,
    color: `${text.main} !important`,
    border: `1px solid rgba(255, 255, 255, 0.08) !important`,
    backgroundImage: "none !important",
    boxShadow: "0 18px 40px rgba(2, 6, 23, 0.36) !important",
  },
  ".MuiCard-root, .MuiTableContainer-root, .MuiAccordion-root": {
    backgroundImage: "none !important",
  },
  ".MuiPaper-root[style*='background-color: white'], .MuiDialog-paper[style*='background-color: white'], .MuiCard-root[style*='background-color: white'], .MuiTableRow-root[style*='background-color: white'], .MuiBox-root[style*='background-color: white'], .MuiPaper-root[style*='background-color: #fff'], .MuiDialog-paper[style*='background-color: #fff'], .MuiCard-root[style*='background-color: #fff']": {
    backgroundColor: `${background.card} !important`,
    color: `${text.main} !important`,
  },
  ".MuiPaper-root[style*='background-color: rgb(255, 255, 255)'], .MuiDialog-paper[style*='background-color: rgb(255, 255, 255)'], .MuiCard-root[style*='background-color: rgb(255, 255, 255)'], .MuiTableRow-root[style*='background-color: rgb(255, 255, 255)'], .MuiBox-root[style*='background-color: rgb(255, 255, 255)'], .MuiPaper-root[style*='background-color: rgb(249, 249, 249)'], .MuiDialog-paper[style*='background-color: rgb(249, 249, 249)'], .MuiCard-root[style*='background-color: rgb(249, 249, 249)'], .MuiPaper-root[style*='background-color: rgb(245, 245, 245)'], .MuiDialog-paper[style*='background-color: rgb(245, 245, 245)'], .MuiCard-root[style*='background-color: rgb(245, 245, 245)']": {
    backgroundColor: `${background.card} !important`,
    color: `${text.main} !important`,
  },
  ".MuiBox-root[style*='background: white'], .MuiBox-root[style*='background:#fff'], .MuiBox-root[style*='background: #fff'], .MuiBox-root[style*='background: rgb(255, 255, 255)'], .MuiBox-root[style*='background: rgb(249, 249, 249)'], .MuiBox-root[style*='background: rgb(245, 245, 245)']": {
    background: `${background.card} !important`,
    color: `${text.main} !important`,
  },
  ".MuiTypography-root[style*='color: white'], .MuiTypography-root[style*='color: rgb(255, 255, 255)'], .MuiTypography-root[style*='color: #fff']": {
    color: `${text.focus} !important`,
  },
  ".MuiTypography-root[style*='color: rgb(0, 0, 0)'], .MuiTypography-root[style*='color: #000'], .MuiTypography-root[style*='color: rgb(51, 51, 51)'], .MuiTypography-root[style*='color: #333']": {
    color: `${text.main} !important`,
  },
  "*[style*='background-color: white'], *[style*='background-color:#fff'], *[style*='background-color: #fff'], *[style*='background-color: rgb(255, 255, 255)'], *[style*='background-color: rgb(249, 249, 249)'], *[style*='background-color: rgb(245, 245, 245)']": {
    backgroundColor: `${background.card} !important`,
    color: `${text.main} !important`,
  },
  "*[style*='background: white'], *[style*='background:#fff'], *[style*='background: #fff'], *[style*='background: rgb(255, 255, 255)'], *[style*='background: rgb(249, 249, 249)'], *[style*='background: rgb(245, 245, 245)']": {
    background: `${background.card} !important`,
    color: `${text.main} !important`,
  },
  "*[style*='color: #000'], *[style*='color:#000'], *[style*='color: rgb(0, 0, 0)'], *[style*='color: #333'], *[style*='color: rgb(51, 51, 51)'], *[style*='color: rgb(29, 27, 37)']": {
    color: `${text.main} !important`,
  },
  ".MuiInputLabel-root, .MuiFormLabel-root, .MuiFormHelperText-root, .MuiFormControlLabel-label, .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows, .MuiTablePagination-input, .MuiTablePagination-toolbar, .MuiTableSortLabel-root, .MuiMenuItem-root, .MuiListItemText-primary, .MuiListItemText-secondary": {
    color: `${text.main} !important`,
  },
  ".MuiTableCell-root": {
    borderColor: "rgba(255, 255, 255, 0.08) !important",
    color: `${text.main} !important`,
  },
  ".MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: `${background.muted} !important`,
    color: `${text.focus} !important`,
  },
  ".MuiTableBody-root .MuiTableRow-root:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.03) !important",
  },
  ".MuiInputBase-root, .MuiOutlinedInput-root, .MuiAutocomplete-inputRoot, .MuiSelect-select, .MuiOutlinedInput-notchedOutline": {
    backgroundColor: "var(--app-field-bg) !important",
    color: "var(--app-field-text) !important",
    borderColor: "var(--app-field-border) !important",
  },
  ".MuiOutlinedInput-notchedOutline, .MuiInputBase-root fieldset": {
    borderColor: "var(--app-field-border) !important",
  },
  ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .MuiInputBase-root:hover fieldset": {
    borderColor: "var(--app-field-border-hover) !important",
  },
  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiInputBase-root.Mui-focused fieldset": {
    borderColor: "var(--app-field-border-focus) !important",
  },
  ".MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator, .MuiSelect-icon, .MuiSvgIcon-root, .material-icons, .material-icons-round, .MuiIconButton-root": {
    color: `${text.main} !important`,
  },
  ".MuiChip-root": {
    border: "1px solid rgba(255, 255, 255, 0.08) !important",
  },
  ".MuiDivider-root": {
    borderColor: "rgba(255, 255, 255, 0.08) !important",
  },
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(2, 6, 23, 0.72) !important",
  },
  ".fc, .fc-theme-standard td, .fc-theme-standard th": {
    borderColor: "rgba(255, 255, 255, 0.08) !important",
    color: `${text.main} !important`,
  },
  "input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus": {
    WebkitTextFillColor: "var(--app-field-text) !important",
    caretColor: "var(--app-field-text) !important",
    WebkitBoxShadow: "0 0 0 1000px var(--app-field-bg) inset !important",
    transition: "background-color 9999s ease-in-out 0s",
  },
};

export default globals;
